const shippingEstimateService = {
    getEstimate: function (project) {
        return Collaterate.Shipping.getEstimate(project)
            // .catch(function(){
            //     //do things - pass to error response handler service...
            // });
    },
    refreshEstimate: function (estimate) {
        return Collaterate.Shipping.refreshEstimate(estimate)
            // .catch(function(){
            //     //do things - pass to error response handler service...
            // });
    },
    setShippingService: function (project, shippingService) {
        return Collaterate.Project.setShippingService(project, shippingService)
            // .catch(function(){
            //     //do things - pass to error response handler service...
            // });
    },
    removeShippingService: function (project) {
        return Collaterate.Project.removeShippingService(project)
    },
    getProductShippingEstimate: function (productIdWithPrefix, totalOunces, countryId, stateId, zip) {
        return fetch('/rest/storefront/shippingQuotes', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ productIdWithPrefix, totalOunces, countryId, stateId, zip })
        })
        .then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
            return res.json();
        })
        .then(data => data.content.shippingServiceQuotes.map(quote => ({
            id: `service-${quote.serviceId}`,
            description: quote.serviceName,
            displayPrice: quote.price.toFixed(2),
            isVendorService: quote.isVendorService,
            internalId: { shippingServiceId: quote.serviceId }
        })));
    },
    getShippingDefaults: function () {
        return fetch('/rest/storefront/shippingQuotes/defaults')
            .then(res => {
                if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
                return res.json();
            })
            .then(data => data.content);
    },
    getShippingCountries: function (siteId) {
        return fetch(`/api/site-service/sites/${siteId}/countries`)
            .then(res => {
                if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
                return res.json();
            })
    },
    setProjectShipToAddress: function (projectId, addressId) {
        return fetch(`/rest/storefront/projects/v2/${projectId}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/merge-patch+json' },
            body: JSON.stringify({
                orderShipmentsShipToAddress: `ADD_${addressId}`
            })
        })
        .then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
            return res.json();
        })
    },
    getProjectShippingEstimate: function (projectId, countryId, stateId, zip, totalOunces) {
        return fetch('/rest/storefront/shippingQuotes', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ projectId, countryId, stateId, zip, totalOunces })
        })
        .then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
            return res.json();
        })
        .then(data => data.content.shippingServiceQuotes.map(quote => ({
            id: `service-${quote.serviceId}`,
            description: quote.serviceName,
            displayPrice: quote.price.toFixed(2),
            isVendorService: quote.isVendorService,
            internalId: { shippingServiceId: quote.serviceId }
        })));
    },
    setProjectShippingService: function (projectId, shippingServiceId, isVendorService, addressId) {
        const payload = {
            shippingService: {
                shippingServiceId: shippingServiceId,
                isVendorService: isVendorService,
                referenceNumber1: null,
                referenceNumber2: null,
                fedExReferenceNumber: null,
                isUSPSService: false
            }
        };

        if (addressId) {
            payload.orderShipmentsShipToAddress = `ADD_${addressId}`;
        }

        return fetch(`/rest/storefront/projects/v2/${projectId}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/merge-patch+json' },
            body: JSON.stringify(payload)
        })
        .then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
            return res.json();
        })
    }
};
export default shippingEstimateService;